/* @flow */
import ActivityDetailContainer from 'payments/containers/ActivityDetailContainer.jsx';
import chainOnEnter from 'components/mixins/chainOnEnter';
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';

import './styles/ActivityDetailView.scss';

const ActivityDetailView = React.createClass({
  propTypes: {
    params: React.PropTypes.object.isRequired,
  },

  mixins: [
    chainOnEnter([RequireUser]),
  ],

  render() {
    return (
      <div className="ActivityDetailView">
        <ActivityDetailContainer activityId={this.props.params.id} />
      </div>
    );
  },
});

export default ActivityDetailView;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityDetailView.jsx